module.exports = __webpack_public_path__ + "img/橙心通-太阳码.eef3abb7.jpg";